import { render, staticRenderFns } from "./OrderTypeToggle.vue?vue&type=template&id=6cbf6708"
import script from "./OrderTypeToggle.vue?vue&type=script&lang=js"
export * from "./OrderTypeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports